module.exports = __webpack_public_path__ + "img/hr-express-splitter-north.62d68142.png";